import { render, staticRenderFns } from "./InventoryCounter.vue?vue&type=template&id=837ee69a&scoped=true"
import script from "./InventoryCounter.vue?vue&type=script&lang=js"
export * from "./InventoryCounter.vue?vue&type=script&lang=js"
import style0 from "./InventoryCounter.vue?vue&type=style&index=0&id=837ee69a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "837ee69a",
  null
  
)

export default component.exports